<template>
  <div>
    <basic-container>
      <el-form :inline="true" ref="form" label-width="70px" :model="form">
        <el-row>
          <el-col span="6">
            <el-form-item label="小区名称" prop="communityId">
              <el-select v-model="form.communityId" @change="select" placeholder="请选择小区">
                <el-option
                  v-for="item in allPropertyList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="费项" prop="costName">
              <el-select v-model="form.costName" @change="select" placeholder="请选择小区">
                <el-option
                  v-for="item in costItemList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="开始时间" prop="payTimeStart">
              <el-date-picker
                v-model="form.payTimeStart"
                type="datetime"
                format="yyyy-MM-dd "
                placeholder="选择开始日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="结束时间" prop="payTimeEnd">
              <el-date-picker
                v-model="form.payTimeEnd"
                type="datetime"
                format="yyyy-MM-dd "
                placeholder="选择结束日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="6">
            <el-form-item label="缴费人" >
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="付款方式">
              <el-select v-model="form.payType" @change="select" placeholder="请选择小区">
                <el-option
                  v-for="item in payTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="款项来源" prop="payChannel">
              <el-select v-model="form.payChannel" @change="select" placeholder="请选择小区">
                <el-option
                  v-for="item in paymentFromList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col span="6">
            <el-form-item label="票据号" prop="invoiceNumber">
              <el-input v-model="form.invoiceNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="22"> </el-col>
          <el-col span="2">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="webReport" :url="url" :params="params" :roomName="roomName" :name="name" />
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WebReport from '@/components/web-report';
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import urlSettings from '@/config/url-settings.js';
import { getCommunityGroupList } from '../../../../api/common';
    import _ from 'lodash';
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      communityGroupList:[],
      url: '',
      form: {
        communityGroup:'',
        communityId: '', //小区id
        costName: '物业费', //费项
        payTimeStart: '', //开始时间
        payTimeEnd: '', //结束时间
        name: '', //缴费人
        payType: '现金', //付款方式
        payChannel: 1, //款项来源
        invoiceNumber: '', //票据号
      },
      costItemList: [
        //费项下拉框
        {
          label: '水费',
          value: '水费',
        },
        {
          label: '月卡车费',
          value: '月卡车费',
        },
        {
          label: '物业费',
          value: '物业费',
        },
        {
          label: '临停车费',
          value: '临停车费',
        },
        {
          label: '预付款',
          value: '预付款',
        },
      ],
      payTypeList: [
        //付款方式
        {
          label: '现金',
          value: '现金',
        },
        {
          label: '银联',
          value: '银联',
        },
        {
          label: '微信',
          value: '微信',
        },
        {
          label: '支付宝',
          value: '支付宝',
        },
        {
          label: '建行',
          value: '建行',
        },
        {
          label: '工行托收',
          value: '工行托收',
        },
        {
          label: '建行托收',
          value: '建行托收',
        },
        {
          label: '水务代收',
          value: '水务代收',
        },
      ],
      paymentFromList: [
        //款项来源
        {
          label: '物业管理系统',
          value: 1,
        },
        {
          label: 'APP在线支付',
          value: 2,
        },
        {
          label: '银行划扣',
          value: 3,
        },
        {
          label: '水务代收',
          value: 4,
        },
        {
          label: '上门面收',
          value: 5,
        },
        {
          label: '其他',
          value: 6,
        },
      ],
      allPropertyList: [],
      params: {
        reportlet: urlSettings.VUE_APP_ENVIRONMENT + '/ispPayRecord.cpt',
        payType: '现金',
        payChannel: 1,
        costName: '物业费',
        communityId: '',
      },
      dic: [],
    };
  },
  methods: {
    onSubmit() {
      this.params.payTimeStart = this.dayjs(this.form.payTimeStart).format('YYYY-MM-DD');
      this.params.payTimeEnd = this.dayjs(this.form.payTimeEnd).format('YYYY-MM-DD');
      this.params.communityId = this.form.communityId;
      this.params.payChannel = this.form.payChannel;
      this.params.name = this.form.name;
      this.params.costName = this.form.costName;
      this.params.payType = this.form.payType;
      this.params.invoiceNumber = this.form.invoiceNumber;
      setTimeout(() => {
        this.$refs.webReport.regroupUrl();
      }, 0);
    },
    initPropertyList(cb) {
      var that = this;
      getOptionNode({communityGroup:that.form.communityGroup}).then((data) => {

        data.data.forEach(item=>{
          item.id = item.id;
        })
         this.allPropertyList = data.data;
         this.form.communityId = this.allPropertyList[0].id;
        this.params.communityId = this.allPropertyList[0].id;
        // this.form.communityId = this.allPropertyList[0].title;
      });
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
  },

  created() {
    this.form.payTimeStart = this.dayjs().startOf('month').format('YYYY-MM-DD');
    this.form.payTimeEnd = this.dayjs().format('YYYY-MM-DD');
    this.params.payTimeStart = this.dayjs().startOf('month').format('YYYY-MM-DD');
    this.params.payTimeEnd = this.dayjs().format('YYYY-MM-DD');
    this.params.account = this.userInfo.account;
    var reportUrl = urlSettings.BASE_REPORT_URL;
    this.url = reportUrl.split('?')[0];
    this.initPropertyList();
  },
};
</script>

